<template>
    <div class="home">
        <sw-parallax
                style="background-image: url('/static/media/home_banner.jpg');" class="hero">
            <div class="container" style="height: 100%;">
                <div class="row" style="height: 100%;">
                    <div class="column" style="height: 100%; position: relative;">
                        <h1 class="slogan">
                            Maak complexe processen eenvoudig
                        </h1>
                    </div>
                </div>
            </div>
        </sw-parallax>
        <div class="container">
            <div class="row">
                <div class="one-half column">
                    <article>
                        <h2>D&eacute; oplossing voor retailers</h2>
                        <p>
                            U denkt vast vaak na over vernieuwing binnen uw organisatie. Bent u op zoek naar
                            vernieuwende technologieën om u daarbij te helpen? SwBase Systems biedt u een modern en
                            compleet cloud-gebaseerd afrekensysteem aan. <router-link to="/services/">Lees meer</router-link>
                        </p>
                    </article>

                    <figure class="side_image small_screen">
                        <img src="../assets/shutterstock_724467730.jpg" width="460" height="306" alt="Open image">
                    </figure>
                </div>
                <div class="one-half column big_screen">
                    <figure class="side_image">
                        <img src="../assets/shutterstock_724467730.jpg" width="460" height="306" alt="Open image">
                    </figure>
                </div>
            </div>

            <div class="row">
                <div class="one-half column">
                    <article>
                        <h2>Wij zijn op zoek naar jou!</h2>
                        <p>
                            Werken binnen het leukste team van Friesland? We’ve got you covered! Op een informele en
                            professionele manier kun jij jezelf bij ons ontwikkelen. Bekijk de vacatures <router-link to="/careers">hier</router-link>
                        </p>
                    </article>
                </div>
                <div class="one-half column">
                    <figure class="side_image">
                        <img src="../assets/home_employee.jpg" width="600" height="353" alt="Open image">
                    </figure>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SwParallax from "@/components/Parallax.vue";

    export default {
        metaInfo: {
            title: "Home",
            meta: [
                {
                    'property': 'og:title',
                    'content': 'Home - SwBase Systems BV - Swbase.com',
                    'vmid': 'og:title'
                },
            ]
        },
        components: {
            SwParallax
        }
    };
</script>

<style scoped="scoped">
    .slogan {
        position: absolute;
        bottom: 50px;
        font-weight: 500;
        font-size: 36px;
        color: white;
    }

    .side_image {
        width: 100%;
        margin-left: 0;
    }

    .side_image img {
        width: 100%;
        height: auto;
    }

    @media (min-width: 750px) {
        .side_image {
            margin-top: 140px;
            width: 100%;
            height: auto;
            margin-left: initial;
        }
    }
</style>